import { UAParser } from 'ua-parser-js';

const uap = new UAParser();
const os = uap.getOS();
const allGameCtaButtons = document.querySelectorAll('.wp-block-button--game');
const allGamePlatformCtaButtons = document.querySelectorAll(
  '.single-game__details-bar__cta__platform',
);
const headerNavCtaButton = document.querySelector(
  '.header__navigation .wp-block-button__link.has-secondary-gradient-background',
);
const headerLogin = document.querySelector('#header__login-btn');

// CTA Buttons
if (allGameCtaButtons.length) {
  allGameCtaButtons.forEach((gameCtaButton) => {
    const desktopCta = gameCtaButton.querySelector('.wp-block-button__link');
    const iosCta = gameCtaButton.querySelector('.wp-block-button__link__app-store-badge');
    const androidCta = gameCtaButton.querySelector('.wp-block-button__link__google-play-badge');

    if (desktopCta) {
      desktopCta.classList.add('device-hidden');
    }

    if (os.name === 'iOS') {
      if (iosCta) iosCta.classList.remove('device-hidden');
    } else if (os.name === 'Android') {
      if (androidCta) androidCta.classList.remove('device-hidden');
    } else if (desktopCta) {
      desktopCta.classList.remove('device-hidden');
    }
  });
}

// Platform CTA Buttons - Located on the single game page in the details bar.
if (allGamePlatformCtaButtons.length) {
  allGamePlatformCtaButtons.forEach((platformCtaButton) => {
    if (os.name === 'iOS' || os.name === 'Android') {
      platformCtaButton.classList.add('device-hidden');
    } else {
      platformCtaButton.classList.remove('device-hidden');
    }
  });
}

// Header CTA Button
if (headerNavCtaButton) {
  if (os.name === 'iOS' || os.name === 'Android') {
    headerNavCtaButton.classList.add('device-hidden');
  } else {
    headerNavCtaButton.classList.remove('device-hidden');
  }
}

// Header Login
if (headerLogin) {
  if (os.name === 'iOS' || os.name === 'Android') {
    headerLogin.classList.add('device-hidden');
  } else {
    headerLogin.classList.remove('device-hidden');
  }
}
